import { faPalette } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import React from "react";
import { useHistory } from "react-router";

export function useWebsiteBuilderLauncher() {
  const history = useHistory();
  const { t } = useTranslation();

  function launchWebsiteBuilder(websiteExists: boolean) {
    if (websiteExists) {
      history.push("/admin/website-builder-editor");
    } else {
      history.push("/admin/website-builder/templates");
    }
  }

  function launchWebsiteBuilderContent(websiteExists: boolean) {
    return (
      <>
        <FontAwesomeIcon icon={faPalette} className="mr-2" />
        {websiteExists ? t("Customize website") : t("Create new website")}
      </>
    );
  }

  return {
    launchWebsiteBuilder,
    launchWebsiteBuilderContent,
  };
}
